function VolunteeringSlice(set, get) {
  return {
    volunteering: {
      isInitialized: false,
      allRows: [],
      filteredRowItems: [],
      causeCategories: [],
      causeCategoryLabels: [],
      filters: { causes: [], timeCommitment: [], searchText: '', location: [] },
      allOpportunities: [],
      volunteersSearchText: '',
    },
  };
}

export default VolunteeringSlice;
